import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'shared/hocs'
import { bindActionCreators } from 'redux'
import RoutesService from 'LiveBoard/services/routes'
import { changeSearchQuery } from 'LiveBoard/modules/itemsView'
import isEmpty from 'lodash/isEmpty'

class SearchContainer extends React.Component {
  handleSearchSubmit = (query) => {
    const {
      searchQuery, board, changeSearchQuery,
      location, navigate
    } = this.props

    if(isEmpty(query) || searchQuery == query ) {
      return
    }

    changeSearchQuery(query)
    const queryParams = new URLSearchParams(location.search)
    queryParams.set("query", query)

    const boardRoute = RoutesService.getBoardRoute(board)

    navigate(`${boardRoute}?${queryParams.toString()}`)
  }

  render() {
    const { showSearchBox, solidBackground, component: Search } = this.props
    return showSearchBox && (
      <Search
        form="search"
        onSubmit={this.handleSearchSubmit}
        solidBackground={solidBackground} />
    )
  }
}

SearchContainer.propTypes = {
  searchQuery: PropTypes.string,
  showSearchBox: PropTypes.bool.isRequired,
  board: PropTypes.object.isRequired,
  changeSearchQuery: PropTypes.func.isRequired,
  solidBackground: PropTypes.bool
}

function mapStateToProps({ board, campaign, itemsView: { query }}) {
  return {
    board: board,
    searchQuery: query,
    showSearchBox: campaign.items.show_search_box
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ changeSearchQuery }, dispatch)
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SearchContainer)
)
